module.exports = __webpack_public_path__ + "img/full.f99fd6e4.svg";